class BlogSearch {
    constructor() {
        this.form = document.querySelector('form[action*="search"] input[name="type"][value="article"]')?.closest('form');
        this.input = this.form?.querySelector('input[type="search"]');
        this.resultsContainer = document.querySelector('#blog-search-results');
        this.originalArticleList = document.querySelector('article-list');
        
        console.log('🚀 Blog Search - Initializing...');
        console.log('📋 Blog Search - Form found:', !!this.form);
        console.log('📋 Blog Search - Input found:', !!this.input);
        console.log('📋 Blog Search - Results container found:', !!this.resultsContainer);
        console.log('📋 Blog Search - Original article list found:', !!this.originalArticleList);
        
        if (!this.form || !this.input || !this.resultsContainer) {
          console.error('❌ Blog Search - Missing required elements!');
          return;
        }
        
        // Prevent form submission, use AJAX instead
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.onChange();
        });
        
        // Debounced input handler
        this.input.addEventListener('input', this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this));
      }
  
      onChange() {
        const searchTerm = this.input.value.trim();
        console.log('⌨️ Blog Search - Input changed, search term:', searchTerm);
        
        if (!searchTerm.length) {
          this.hideResults();
          return;
        }
        
        this.getSearchResults(searchTerm);
      }
  
    getSearchResults(searchTerm) {
        const sectionId = this.resultsContainer?.dataset?.sectionId || 'blog-search-results';
        
        // Try to find the actual section ID on the page if section was added to template
        const sectionElement = document.querySelector('[id*="blog-search-results"]');
        const fullSectionId = sectionElement?.id || sectionId;
        
        const url = `/search?q=${encodeURIComponent(searchTerm)}&type=article&section_id=${fullSectionId}`;
        console.log('🔍 Blog Search - Fetching:', url);
        console.log('🔍 Blog Search - Section ID:', fullSectionId);
        
        fetch(url)
        .then((response) => {
          console.log('📡 Blog Search - Response status:', response.status, response.ok);
          if (!response.ok) {
            var error = new Error(response.status);
            this.hideResults();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
            console.log('📄 Blog Search - Raw response text length:', text.length);
            console.log('📄 Blog Search - Response preview:', text.substring(0, 500));
            
            const parsedDoc = new DOMParser().parseFromString(text, 'text/html');
            const sectionElement = parsedDoc.querySelector('#shopify-section-blog-search-results');
            
            console.log('🔎 Blog Search - Section element found:', !!sectionElement);
            
            if (sectionElement) {
              const resultsMarkup = sectionElement.innerHTML;
              console.log('📦 Blog Search - Results markup length:', resultsMarkup.length);
              console.log('📦 Blog Search - Results markup preview:', resultsMarkup.substring(0, 500));
              
              this.resultsContainer.innerHTML = resultsMarkup;
              
              // Initialize lazy loading IMMEDIATELY for new images (no debounce)
              if (window.LazyImageLoader) {
                window.__lazyImageLoaderActive = false; // Reset flag
                new window.LazyImageLoader();
              }
              
              this.showResults();
              console.log('✅ Blog Search - Results displayed');
            } else {
              console.error('❌ Blog Search - Section element not found!');
              console.log('📄 Blog Search - Full HTML:', text);
              this.hideResults();
            }
        })
        .catch((error) => {
          console.error('❌ Blog Search - Error:', error);
          this.hideResults();
        });
    }
  
    showResults() {
        if (this.resultsContainer) {
          this.resultsContainer.style.display = 'block';
          // Optionally hide original article list
          if (this.originalArticleList) {
            this.originalArticleList.style.display = 'none';
          }
        }
      }
  
      hideResults() {
        if (this.resultsContainer) {
          this.resultsContainer.style.display = 'none';
          // Show original article list again
          if (this.originalArticleList) {
            this.originalArticleList.style.display = 'block';
          }
        }
      }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new BlogSearch());
  } else {
    new BlogSearch();
  }